import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';

import { WidgetGroup } from '../widget/config.widget.model';
import { WidgetComponentConfig } from '../widget/widget.component';
import { WidgetService } from '../widget/widget.service';

import { TranslationKeyMap } from './pulse.i18n';

@Component({
    selector: 'cmps-pulse',
    templateUrl: './pulse.component.html',
})
export class PulseComponent implements OnInit {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    groupConfig: WidgetGroup;
    configs: WidgetComponentConfig[];

    constructor(private readonly _widgetService: WidgetService) {}

    ngOnInit(): void {
        this.hasPendingData = true;
        this._widgetService
            .widgetConfigurations()
            .pipe(
                tap((data) => {
                    this.groupConfig = data;
                    const configWidgets = this.groupConfig.configurations
                        .map((value) => ({
                            config: value,
                            widget: this._widgetService.widgets.find(
                                (w) => w.typeId === value.typeId,
                            ),
                        }))
                        .filter((value) => {
                            if (!value.widget) {
                                console.log(
                                    'widget not found',
                                    value.config.typeId,
                                );
                                return false;
                            }
                            return true;
                        });
                    this.configs = configWidgets.map((value) => {
                        const { config, widget } = value;
                        const id = `cmpsWidget${(
                            Math.random() * 100000
                        ).toFixed()}`;
                        return {
                            id,
                            header: config.title,
                            component: widget.component,
                            config,
                            noEncapsulate: widget.noEncapsulate,
                        };
                    });
                }),
            )
            .subscribe(
                () => null,
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }
}
